enum SDSA2AOutboundStatuses {
  'airport-preslot' = 1,
  'driver' = 2,
  'processing' = 3,
  'complete' = 4
}

export default SDSA2AOutboundStatuses;



// WEBPACK FOOTER //
// ./src/enum/SDS-A2A-outbound-status.enum.ts